

$(document).ready(function () {
    geoLocalization();

});

function geoLocalization() {
    if (findSessionCookies()) {
        var contactPhone = sessionStorage['ContactPhone'];
        addCountryContacttoMainMenu(contactPhone);
        addCountryContacttoMobileMenu(contactPhone);
    }
    else {
        $.getJSON("https://api.ipify.org?format=json",
            function (data) {
                $.getJSON("/Sitefinity/Public/Services/GeoLocation/GeoLocation.svc/" + data.ip,
                    function () {
                    })
                    .done(function (userIpCountry) {
                        var jsonParse = JSON.parse(userIpCountry);

                        if (jsonParse.ErrorMessage) {
                            alert("Error ocurred while detecting user location");
                        } else {
                            searchCountryContact(jsonParse.Country);
                            return userIpCountry;
                        }

                    })
                    .fail(function () {
                        alert("Error ocurred while detecting user location");
                    });
            });
    }
    

}

function findSessionCookies() {
    if (sessionStorage['ContactPhone'] != undefined && sessionStorage['ContactPhone'] != "") {
        return true;
    }
    else {
        return false;
    }


}

function searchCountryContact(country) {
    var options = {
        url: "/elcawheretofindus/searchContactCountryPhone",
        data: "country=" + country,
        async: true,
        type: "PUT",
        success: function (result) {
            if (result != "" && result != null) {
                sessionStorage['ContactPhone'] = result;
                addCountryContacttoMainMenu(result);
                addCountryContacttoMobileMenu(result);
            }
        },
        error: function () {
            alert("Error loading the phone number for active country in menu");
        }
    };
    return $.ajax(options);

}

function addCountryContacttoMainMenu(result) {
    if ($("#mi-corpo-contactphone-number").text() != result) {
        $("#mi-corpo-contactphone-number").append(result);
        $("#mi-corpo-header-menu-item-contactphone").removeClass("DisplayNone");
    }
    
}

function addCountryContacttoMobileMenu(result) {
    if ($("#mi-corpo-mobile-geocountrycontact").text() != result) {
        var contactPhraseNode = $("#mi-mobile-geocountrycontactphrase");
        //var contactPhraseNode = $("#responsiveMenu");
        var ele = document.createElement("a");
        ele.className = "mi-corpo-mobile-geocountrycontact";
        ele.id = "mi-corpo-mobile-geocountrycontact";
        ele.href = "tel:" + result;
        ele.innerHTML = result;
        contactPhraseNode.append(ele);
    }
}
